import * as Sentry from '@sentry/react';
import { PrimeReactProvider } from 'primereact/api';
import 'primeicons/primeicons.css';
import ReactDOM from 'react-dom/client';

import './main.css';

import App from '@/App.tsx';
import { initSentry } from '@/sentry.ts';

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </Sentry.ErrorBoundary>
);
